__turbopack_context__.v({
  "arrowButton": "EmblaCarouselArrowButtons-module-scss-module__fZoo-G__arrowButton",
});
